import { Injectable } from "@angular/core";
import { HomeNotificationModel } from "../model/dto.models.imported";


@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    public lastNotificationsCheckedAt : Record<string, Date> = {}
    public lastNotificationsPersCheckedAt : Record<string, Date> = {}
    public notifications : Record<string, HomeNotificationModel[]> = {}

}
